import type { FC } from 'react';
import { File, RotateCcw, Trash2 } from 'lucide-react';

interface ErrorPreviewFileProps {
  name: string;
  message: string;
  onRetry: () => void;
  onRemove: () => void;
}

export const ErrorPreview: FC<ErrorPreviewFileProps> = ({ name, onRetry, onRemove, message }) => {
  return (
    <div className="w-full lg:h-24 py-4 lg:py-5 px-4 lg:px-5 rounded-md flex justify-between gap-4 bg-(--danger-D200)">
      <div className="flex items-center gap-3">
        <File className="lg:h-[42px] lg:w-[42px]" strokeWidth={1} />
        <div className="flex flex-col gap-1 lg:gap-2 items-start">
          <div className="text-left leading-tight [font-family:var(--font-montserrat)]! [font-size:var(--fs-l4)]! medium text-(--neutral-black-NB1000)">
            {name}
          </div>
          <div className="text-left leading-tight [font-family:var(--font-montserrat)]! [font-size:var(--fs-l5)]! medium text-(--danger-D700)">
            {message}
          </div>
        </div>
      </div>
      <div className="ml-auto flex items-center gap-2 lg:gap-4">
        <button
          type="button"
          onClick={onRemove}
          className="self-center ml-auto flex h-9 w-9 items-center justify-center rounded-full! bg-(--neutral-black-NB700)/10 text-(--neutral-black-NB700)"
        >
          <Trash2
            className="h-5 w-5 text-(--neutral-black-NB600) cursor-pointer"
            strokeWidth={1.5}
          />
        </button>

        <button
          type="button"
          onClick={onRetry}
          className="flex items-center justify-center px-2 py-2 bold [font-family:var(--font-arvo)]! [font-size:var(--fs-b2)]! text-(--neutral-white-NW1000)! bg-(--primary-O900) rounded-full!"
        >
          <RotateCcw
            className="h-5 w-5 text-(--neutral-white-NW1000) cursor-pointer"
            strokeWidth={2}
          />
        </button>
      </div>
    </div>
  );
};
